import { global} from "../Common/saop-common";
import { SaopWebGrid,SaopWebGridProperties,SaopWebGridToolbar,SaopWebDataTable} from "../Components/saop-grid";
import { SaopInputMask } from "../Components/saop-inputmask";
import * as moment from '../../node_modules/moment/moment';
import { SaopServicesCore } from "../Core/saop-services-core";

export interface IOPNPrehodiMejeGridRow {
    LetoPotnegaNaloga: string;
    StevilkaPotnegaNaloga: string;
    ZaporednaStevilka: string;
    tr:any;
}

export class OPNPrehodiMejeGrid {
    private _libName: string;
    private _parentFormId: string;
    private _wgId: string;
    private _formId: string;
    private _borderCrossingsAjax: JQuery<HTMLElement>;
    public webGrid1:SaopWebGrid;

    constructor(libName: string, parentFormId: string) {
        this._libName = libName;
        this._parentFormId = parentFormId;
        this._formId = "#OPNPrehodiMejeForm";
        this._wgId = "#OPNPrehodiMejeGrid";
    }

    renderTableData():void{
        global.ConsoleLogDegug("OPNPrehodiMejeGrid.renderTableData");  

        this._borderCrossingsAjax = $("#borderCrossingsAjax");
        if (this._borderCrossingsAjax.length == 0){
            return;
        }

        var _val = $("#BorderCrossingsRowsParams").val();
        if (_val != null && _val.toString().length > 0){
            this.reloadTableData(_val.toString());
            return;
        }

        let _this = this;

        let _letoPotnegaNaloga = $("#LetoPotnegaNaloga").val();
        let _stevilkaPotnegaNaloga = $("#StevilkaPotnegaNaloga").val();

        let _params = { letoPotnegaNaloga: _letoPotnegaNaloga, stevilkaPotnegaNaloga: _stevilkaPotnegaNaloga };

        let _saopServicesCore = new SaopServicesCore();
        _saopServicesCore.afterDone = function (response) {
            _this._borderCrossingsAjax.html(response);

            _this.initListners();
            _this.updateRowIds();
        };
        _saopServicesCore.ExecuteAction({
            action: "TravelOrder/GetBorderCrossingsView"
            , data: _params
            , type: "GET"
            , spinnerDivId: "#saopLoading"
        }); 
    }

    reloadTableData(_params:string):void {
        global.ConsoleLogDegug("OPNPrehodiMejeGrid.ReloadBorderCrossingsRows");  
        let _this = this;

        $(_this._wgId).empty();

        let _saopServicesCore = new SaopServicesCore();
        _saopServicesCore.afterDone = function (response) {
       
            _this._borderCrossingsAjax.html(response);

            _this.initListners();
            _this.updateRowIds();
        };
        _saopServicesCore.ExecuteAction({
            action: "TravelOrder/ReloadBorderCrossingsRows"
            , data: _params
            , type: "POST"
            , spinnerDivId: "#saopLoading"
        });         
    }

    initWebGrid1():void {
        global.ConsoleLogDegug("OPNPrehodiMejeGrid.initWebGrid1");

        
        let captionToolbar = $(this._wgId).attr("caption-toolbar") || "";
        //
        this.webGrid1 = new SaopWebGrid(this._libName+".webGrid1");
        let gridProperties: SaopWebGridProperties;
        let gridToolbar:SaopWebGridToolbar;
        let dataTable:SaopWebDataTable;
        //
        gridToolbar = {id:"saopWebGridTB1",caption:captionToolbar};
   
        dataTable = {enabled:true,ordering:false};

        gridProperties = {
            gridId:this._wgId
            ,togglePanel:{enabled:false}
            ,toolbar:gridToolbar
            ,dataTable:dataTable
            };        
        //
        this.webGrid1.init(gridProperties);   
    }
    //

    initListners():void {
       global.ConsoleLogDegug("OPNPrehodiMejeGrid.init1Listners");


        let saopInputMask = new SaopInputMask();
        saopInputMask.init();

        $(this._wgId+" input").on("blur", this.onCellChange.bind(this));        

        $(this._formId+" #btnAdd").off("click");
        $(this._formId+" #btnAdd").on("click", this.addNewRow.bind(this));     
        
        $(this._formId+" .delete-row").off("click");
        $(this._formId+" .delete-row").on("click", this.deleteRow.bind(this));          
    }

    getRowData(e:any):IOPNPrehodiMejeGridRow {
        var _result = {} as IOPNPrehodiMejeGridRow;
        var _input = $(e.target);
        //console.log(_input.val());

        let _tr = _input.closest("tr");
        _result.tr = _tr;
        _result.LetoPotnegaNaloga = _tr.attr("data-leto");
        _result.StevilkaPotnegaNaloga = _tr.attr("data-stevilka");
        _result.ZaporednaStevilka = _tr.attr("data-zstevilka");

        return _result;
    }

    onCellChange(e:any):void {
        global.ConsoleLogDegug("OPNPrehodiMejeGrid.onCellChange");
        var _row = this.getRowData(e);
        this.updateRowDuration(_row.tr);   
    }    

    updateRowDuration(tr:any):void {
        global.ConsoleLogDegug("OPNPrehodiMejeGrid.updateRowDuration");

        let _CasZacetka = tr.find("input.CasZacetka");
        let _CasKonca = tr.find("input.CasKonca");
        let _Trajanje = tr.find(".Trajanje");

        let parsed_CasZacetka = moment(_CasZacetka.val(),"DD.MM.YYYY hh:mm:ss");

        let parsed_CasKonca = moment(_CasKonca.val(),"DD.MM.YYYY hh:mm:ss");

        if (parsed_CasZacetka.isValid() == false || parsed_CasKonca.isValid() == false){
            _Trajanje.text("");
            $("#BorderCrossingsRowsParams").val($(this._formId).serialize());      
            return;
        }

        var duration = moment.duration(parsed_CasKonca.diff(parsed_CasZacetka));

        let _diffDays = Math.floor(duration.asDays());
        let _diffHours = Math.floor(duration.asMinutes() / 60 ) % 24;        
        let _diffMinutes = duration.asMinutes() % 60;  
        
        //0 dni 8 h 0 min
        let _text = ""+_diffDays.toString()+" dni "+_diffHours.toString()+" h "+_diffMinutes.toString()+" min";	

        _Trajanje.text(_text);

        $("#BorderCrossingsRowsParams").val($(this._formId).serialize());
        //console.log(_text);
    }

    addNewRow(e:any):void {
        global.ConsoleLogDegug("OPNPrehodiMejeGrid.addNewRow");  
        let _this = this;

        let _dejanskiCasOdhodaParent= $(this._parentFormId).find("#DejanskiCasOdhoda").val();
        $(this._formId).find("#DejanskiCasOdhoda").val(_dejanskiCasOdhodaParent);

        let _dejanskiCasPrihodaParent= $(this._parentFormId).find("#DejanskiCasPrihoda").val();
        $(this._formId).find("#DejanskiCasPrihoda").val(_dejanskiCasPrihodaParent);

        let formData = $(this._formId).serialize();

        let _saopServicesCore = new SaopServicesCore();
        _saopServicesCore.afterDone = function (response) {
            let _r = $(response);
            let _newData = _r.find(_this._wgId);
            $(_this._wgId).html(_newData.html());

            _this.initListners();
            _this.updateRowIds();
        };
        _saopServicesCore.ExecuteAction({
            action: "TravelOrder/GetBorderCrossingsNewRow"
            , data: formData
            , type: "POST"
            , spinnerDivId: "#saopLoading"
        }); 
    }

    deleteRow(e:any):void {
        global.ConsoleLogDegug("OPNPrehodiMejeGrid.deleteRow");  
        let _this = this;
        var _row = this.getRowData(e);

        let _input = _row.tr.find("input.deleteRowVal");
        _input.val("T");

        let formData = $(this._formId).serialize();

        let _saopServicesCore = new SaopServicesCore();
        _saopServicesCore.afterDone = function (response) {
            let _r = $(response);
            let _newData = _r.find(_this._wgId);
          
            $(_this._wgId).html(_newData.html());            

            _this.initListners();
            _this.updateRowIds();
        };
        _saopServicesCore.ExecuteAction({
            action: "TravelOrder/DeleteBorderCrossingsRows"
            , data: formData
            , type: "POST"
            , spinnerDivId: "#saopLoading"
        });         
    }

    updateRowIds():void{
        var _this = this;
        $('#OPNPrehodiMejeGrid tbody tr').each(function(index) {
            // Set serial number in the second cell (index 1)
            $(this).find('td').eq(1).text(index + 1);
            $(this).find('td input.zstevilkaVal').val(index + 1);
            _this.updateRowDuration($(this));
        });        
        $("#BorderCrossingsRowsParams").val($(_this._formId).serialize());      
    }
    //

}

